$(document).ready(function() {
    let itemsToShow = 4;

    function handleShowMore(button) {
        let container = button.closest('.u-center-element').prev('.load-cta');
        let loadCta = container;
        let noMoreItems = button.siblings('.load-cta__text'); // Use button.siblings to find the text element

        // Show the first few items
        loadCta.find('.load-cta__elements:lt(' + itemsToShow + ')').show();

        button.click(function() {
            let visibleItems = loadCta.find('.load-cta__elements:visible');
            let hiddenItems = loadCta.find('.load-cta__elements:hidden');
            let itemsSlice = hiddenItems.slice(0, itemsToShow);

            if (itemsSlice.length > 0) {
                itemsSlice.show();
            } else {
                button.hide(); // Hide the button
                noMoreItems.show(); // Show the "No hay más elementos" text
            }
        });
    }

    // Apply the functionality to each container
    $('.show-more').each(function() {
        handleShowMore($(this));
    });
});